import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { UtilService } from '../../shared/util.service';

export interface DataRateItem {
  label: string;
  percentage: number;
  showIndicator?: boolean;
  indicatorColor?: 'green' | 'blue' | 'yellow' | 'orange' | 'red' | 'gray';
  tooltipStatus?: string;
  labelTooltip?: string;
}

@Component({
    selector: 'mh-data-rate-widget',
    templateUrl: './data-rate-widget.component.html',
    styleUrls: ['./data-rate-widget.component.scss'],
    standalone: false
})
export class DataRateWidgetComponent implements OnInit {
  utilService = inject(UtilService);

  @Input() title: string = '';
  @Input() tooltipTitle: string = '';
  @Input() grayTitle: string = '';
  @Input() totalPercentage: number = 0;
  @Input() subTitlePercentage: string = '';
  @Input() description: string = '';
  @Input() typeDescription: 'listOfPercentages' | 'text' = 'listOfPercentages';
  @Input() typeRate: 'percentage' | 'number' | 'empty' = 'percentage';
  @Input() formatType: 'decimal' | 'percent' | 'integer' = 'percent';
  @Input() items: DataRateItem[] = [];
  @Input() showIndicators: boolean = true;
  @Input() loading: boolean = false;
  @Input() qualification: 'excellent' | 'good' | 'regular' | 'bad' | 'very_bad' = 'excellent';
  @Input() hideQualification: boolean = false;
  @Input() productId: number;
  @Input() report: string;
  @Input() slugReportButton: string;
  @Input() dates: any;
  @Input() isSuperAdmin = false;
  @Input() blockSuperAdminActions = false;
  @Input() second_button_text: string;
  @Input() leftFooterText: string = '';
  @Input() textPrincipalButton: string = '';
  @Input() maxValue: number = 100;
  @Input() subTitle: string = '';
  @Input() secondButtonTooltip: string = '';
  @Input() leftFooterTooltip: string = '';
  @Input() tooltipGraph: string | null = null;
  @Input('heigth') height: string = '223px';
  @Input() style: '' | 'space-between' = '';
  @Input() masculineText: boolean = false;
  @Input() hidePrincipalButton: boolean = false;
  @Input() blurPhones: boolean = false;
  @Input() blurWhatsapp: boolean = false;
  @Input() hideStatusIndicators: boolean = false;

  @Output() onViewMore = new EventEmitter<void>();
  @Output() onExport = new EventEmitter<void>();
  @Output() onSecondButtonClick = new EventEmitter<void>();
  @Input() secondButtonStart: boolean = false;
  @Input() customTextClasses: string = '';

  constructor() { }

  ngOnInit(): void {
    
    // Si no se proveen items, usar valores predeterminados
    if (!this.items || this.items.length === 0) {
      this.items = [];
    }

    // Asignar valores por defecto a cualquier propiedad faltante
    this.items.forEach(item => {
      if (item.showIndicator === undefined) {
        item.showIndicator = true;
      }
      if (!item.indicatorColor) {
        item.indicatorColor = 'green';
      }
    });
  }

  handleViewMore(): void {
    this.onViewMore.emit();
  }

  handleSecondButtonClick(): void {
    if (this.blockSuperAdminActions && this.isSuperAdmin) return;
    this.onSecondButtonClick.emit();
  }

  clickReport() {
    this.utilService.ga(
      '',
      (this.productId === 1 ? 'followup' : 'onsite') + '-datawidget-report',
    );
  }

  get spinnerPercentage(): number {
    if (this.totalPercentage === null || this.totalPercentage === undefined || this.maxValue === 0) return 0;
    
    // Convertir a un porcentaje relativo (0-100%)
    const percentage = (this.totalPercentage / this.maxValue) * 100;
    
    // Asegurar que no exceda el 100%
    return Math.min(percentage, 100);
  }

  get secondButtonClasses(): string {
    return this.secondButtonStart ? 'tw-w-full tw-justify-between' : 'tw-justify-end';
  }

  get styleButtons(): string {
    return this.style === 'space-between' ? '' : 'tw-mt-auto';
  }
} 